import * as React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { S1GO_Customer } from "../../data/API/Suppliers";

interface ManualMembersModalProps {
  showAddManualModal: boolean;
  newManualOrgId: string;
  newManualName: string;
  newManualEmail: string;
  submitAddManual: () => void;
  addManualSaving: boolean;
  addManualError: string | null;
  setShowAddManualModal: React.Dispatch<React.SetStateAction<boolean>>;
  setNewManualOrgId: React.Dispatch<React.SetStateAction<string>>;
  setNewManualName: React.Dispatch<React.SetStateAction<string>>;
  setNewManualEmail: React.Dispatch<React.SetStateAction<string>>;
  s1GoCustomers: S1GO_Customer[];
}

export const ManulMembersModal = ({
  showAddManualModal,
  newManualOrgId,
  newManualName,
  newManualEmail,
  submitAddManual,
  addManualSaving,
  addManualError,
  setNewManualEmail,
  setNewManualName,
  setNewManualOrgId,
  setShowAddManualModal,
  s1GoCustomers,
}: ManualMembersModalProps): JSX.Element => {
    console.log(s1GoCustomers,'IN I MODAL')
  const selectedCustomer = React.useMemo(() => {
    return s1GoCustomers.find((c) => c.customerOrgId === newManualOrgId);
  }, [s1GoCustomers, newManualOrgId]);

  const typeaheadOptions = React.useMemo(() => {
    return s1GoCustomers.map((customer) => ({
      ...customer,
      label: `${customer.customerName} - ${customer.customerOrgId}`,
    }));
  }, [s1GoCustomers]);

  const handleClose = () => {
    setShowAddManualModal(false);
  };

  return (
    <Modal show={showAddManualModal} onHide={handleClose} centered>
      <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}>
        <Modal.Title>Lägg till företag</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{backgroundColor:'#fffaf5'}}>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <div>
  <label>Företag</label>
  <Typeahead 
    positionFixed
    id="manual-member-orgnr"
    options={s1GoCustomers.map(
      (customer) => `${customer.customerName} - ${customer.customerOrgId}`
    )}
    placeholder="Sök företag eller orgnr..."
    minLength={0}
   
    selected={
      newManualOrgId && newManualName
        ? [`${newManualName} - ${newManualOrgId}`]
        : []
    }
    onChange={(selected) => {
      if (selected.length > 0) {
        const selectedValue = selected[0] as string;
        const orgNr = selectedValue.split(" - ").pop()?.trim() ?? "";

        const foundCustomer = s1GoCustomers.find(
          (customer) => customer.customerOrgId === orgNr
        );

        if (foundCustomer) {
          setNewManualOrgId(foundCustomer.customerOrgId);
          setNewManualName(foundCustomer.customerName ?? "");
          setNewManualEmail(foundCustomer.customerEmail ?? "");
        }
      }
    }}
    onInputChange={(text) => {
      if (!text.trim()) {
        setNewManualOrgId("");
        setNewManualName("");
        setNewManualEmail("");
      }
    }}
  />
</div>

          <div>
            <label>Företagsnamn</label>
            <input
              className="form-control"
              value={newManualName}
              onChange={(e) => setNewManualName(e.target.value)}
            />
          </div>

          <div>
            <label>E-post</label>
            <input
              className="form-control"
              type="email"
              value={newManualEmail}
              onChange={(e) => setNewManualEmail(e.target.value)}
            />
          </div>

          {addManualError && <div style={{ color: "#DC143C" }}>{addManualError}</div>}
        </div>
      </Modal.Body>

      <Modal.Footer style={{backgroundColor:'#fffaf5'}}>
        <button
          className="btn button-cancel"
          onClick={handleClose}
          disabled={addManualSaving}
        >
          Avbryt
        </button>

        <button
          className="btn"
          onClick={submitAddManual}
          disabled={
            addManualSaving ||
            !newManualOrgId.trim() ||
            !newManualName.trim() ||
            !newManualEmail.trim()
          }
        >
          {addManualSaving ? (
            <Spinner
              as="span"
              size="sm"
              animation="border"
              role="status"
              aria-hidden="true"
            />
          ) : (
            "Spara"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};